import { render, staticRenderFns } from "./AddressAutocomplete.vue?vue&type=template&id=8813b35c&"
import script from "./AddressAutocomplete.vue?vue&type=script&lang=js&"
export * from "./AddressAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./AddressAutocomplete.vue?vue&type=style&index=0&id=8813b35c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports